export const searchParamsNames = {
  query: 'query',
} as const;
